import { observer } from 'mobx-react-lite'
import { type NotificationsSidebarViewModel } from '@/features/notifications/NotificationsSidebarViewModel'
import { useHotkey } from '@/hooks/keyboard-hooks'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { NotificationsSidebar } from '@/features/notifications/components/NotificationsSidebar'
import { NotificationsSidebarHeaderContainer } from '@/features/notifications/components/NotificationsSidebar/NotificationsSidebarHeader/NotificationsSidebarHeaderContainer'
import { NotificationsSidebarMenu } from '@/features/notifications/components/NotificationsSidebar/NotificationsSidebarMenu'
import { NotificationListContainer } from '@/features/notifications/components/NotificationList/NotificationListContainer'

export interface NotificationsSidebarContainerProps {
  vm: NotificationsSidebarViewModel
}

export const NotificationsSidebarContainer = observer(
  function NotificationsSidebarContainer({
    vm,
  }: NotificationsSidebarContainerProps) {
    useHotkey(['Escape'], vm.modal.close)
    const { connectRef: mainRef, scrollYStart: scrollOffset } =
      useScrollOffsets()
    return (
      <NotificationsSidebar
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        mainRef={mainRef}
        menu={<NotificationsSidebarMenu onClose={vm.modal.close} />}
        header={
          <NotificationsSidebarHeaderContainer
            vm={vm}
            scrollOffset={scrollOffset}
          />
        }
        list={<NotificationListContainer vm={vm.list} />}
      />
    )
  },
)
